import { PermissionLevel } from '@/utils/permission';
export const invoicingRoutes = [
  {
    component: () => import('@/pages/masterdata/exactinstances/index.vue'),
    meta: {
      permissions: [{ ExactInstance: PermissionLevel.Read }],
      title: 'menu_admin_exact_instances'
    },
    name: 'ExactInstances',
    path: 'exact-instances'
  },
  {
    component: () => import('@/pages/masterdata/exactinstances/create.vue'),
    hidden: true,
    meta: {
      icon: 'edit',
      permissions: [{ ExactInstance: PermissionLevel.Write }],
      title: 'createExactInstance'
    },
    name: 'CreateExactInstance',
    path: 'exact-instances/create'
  },
  {
    component: () => import('@/pages/masterdata/exactinstances/edit.vue'),
    hidden: true,
    meta: {
      noCache: true,
      permissions: [{ ExactInstance: PermissionLevel.Read }],
      title: 'editExactInstance'
    },
    name: 'EditExactInstance',
    path: 'exact-instances/edit/:id'
  },
  {
    component: () => import('@/pages/masterdata/vattypes/index.vue'),
    meta: {
      permissions: [{ VatType: PermissionLevel.Read }],
      title: 'menu_admin_vattypes'
    },
    name: 'VATTypes',
    path: 'vattypes'
  },
  {
    component: () => import('@/pages/masterdata/vattypes/create.vue'),
    hidden: true,
    meta: {
      icon: 'edit',
      permissions: [{ VatType: PermissionLevel.Write }],
      title: 'createVatType'
    },
    name: 'CreateVatType',
    path: 'vattypes/create'
  },
  {
    component: () => import('@/pages/masterdata/vattypes/edit.vue'),
    hidden: true,
    meta: {
      noCache: true,
      permissions: [{ VatType: PermissionLevel.Read }],
      title: 'editVatType'
    },
    name: 'EditVatType',
    path: 'vattypes/edit/:id'
  },
  {
    component: () => import('@/pages/masterdata/currencies/index.vue'),
    meta: {
      permissions: [{ Currency: PermissionLevel.Read }],
      title: 'menu_currencies'
    },
    name: 'Currencies',
    path: 'currencies'
  },
  {
    component: () => import('@/pages/masterdata/currencies/create.vue'),
    hidden: true,
    meta: {
      permissions: [{ Currency: PermissionLevel.Write }],
      title: 'createCurrency'
    },
    name: 'CreateCurrency',
    path: 'currencies/create'
  },
  {
    component: () => import('@/pages/masterdata/currencies/edit.vue'),
    hidden: true,
    meta: {
      permissions: [{ Currency: PermissionLevel.Read }],
      title: 'editCurrency'
    },
    name: 'EditCurrency',
    path: 'currencies/edit/:id(\\d+)'
  },
  {
    component: () => import('@/pages/masterdata/domains/pricelistitems/pricelistitemprices/edit.vue'),
    hidden: true,
    meta: {
      permissions: [{ PriceListItemPrice: PermissionLevel.Read }],
      title: 'editPriceListItemPrice'
    },
    name: 'EditPriceListItemPrice',
    path: 'domains/edit/:domainID/price-list-items/edit/:id/price-list-item-prices/edit'
  },
  {
    component: () => import('@/pages/masterdata/domains/pricelistitems/create.vue'),
    hidden: true,
    meta: {
      permissions: [{ PriceListItem: PermissionLevel.Write }],
      title: 'createPriceListItem'
    },
    name: 'CreatePriceListItem',
    path: 'domains/edit/:domainID/price-list-items/create'
  },
  {
    component: () => import('@/pages/masterdata/domains/pricelistitems/edit.vue'),
    hidden: true,
    meta: {
      permissions: [{ PriceListItem: PermissionLevel.Read }],
      title: 'editPriceListItem'
    },
    name: 'EditPriceListItem',
    path: 'domains/edit/:domainID/price-list-items/edit/:id(\\d+)'
  }
];
